/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M21.3 181.3h213.3V227H21.3zM21.3 105.1h213.3v45.7H21.3zM21.3 28.9h213.3v45.7H21.3z"/>'
  }
})
